import { createAsyncThunk } from "@reduxjs/toolkit";
import * as expensesService from "../../services/expenses";

export const getWorkers = createAsyncThunk(
  "expenses/getWorkers",
  async () => {
    return await expensesService.fetchWorkers();
  }
);

export const saveWorker = createAsyncThunk(
  "expenses/saveWorker",
  async ({ id, ...workerData }) => {
    if (id) {
      return await expensesService.updateWorker(id, workerData);
    }
    return await expensesService.createWorker(workerData);
  }
);

export const removeWorker = createAsyncThunk(
  "expenses/removeWorker",
  async (id) => {
    await expensesService.deleteWorker(id);
    return id;
  }
);

export const getLocalConcepts = createAsyncThunk(
  "expenses/getLocalConcepts",
  async () => {
    return await expensesService.fetchLocalConcepts();
  }
);

export const saveLocalConcept = createAsyncThunk(
  "expenses/saveLocalConcept",
  async (conceptData) => {
    return await expensesService.createLocalConcept(conceptData);
  }
);

export const removeLocalConcept = createAsyncThunk(
  "expenses/removeLocalConcept",
  async (id) => {
    await expensesService.deleteLocalConcept(id);
    return id;
  }
);

export const getExpenseRecords = createAsyncThunk(
  "expenses/getExpenseRecords",
  async (period) => {
    return await expensesService.fetchExpenseRecordsByPeriod(period);
  }
);

export const saveExpenseRecord = createAsyncThunk(
  "expenses/saveExpenseRecord",
  async (recordData) => {
    return await expensesService.saveExpenseRecord(recordData);
  }
);

export const removeExpenseRecord = createAsyncThunk(
  "expenses/removeExpenseRecord",
  async ({ id, treasuryTxId }) => {
    await expensesService.deleteExpenseRecord(id, treasuryTxId);
    return id;
  }
);
